import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { FolderLabel } from "../FolderLabel";
import { PlanNameList } from "../PlanNameList";
import { TableHeaderRow } from "../TableHeaderRow";
import { ValueName } from "../../ValueName";
import { UNASSIGNED_AXIS_KEY } from "../constants";
import { COMBINED_FOLDER_NAME_SEPARATOR } from "../../constants";
import type { FoldersPerCellProps } from "./types";

export const FoldersPerCell = ({
  table,
  planNameById,
}: FoldersPerCellProps) => {
  const { t } = useTranslation();

  const { rows, columns, floorPlanIdsByCell } = table;

  return (
    <>
      <TableHeaderRow table={table} />
      {rows.values.map((rowValue, rowIndex) => (
        <div
          key={rowValue?.code ?? UNASSIGNED_AXIS_KEY}
          className="col-span-full grid grid-cols-subgrid border-x border-transparent"
        >
          {rows.key !== null && (
            <ValueName
              fileCode={rowValue?.fileCode ?? null}
              name={
                rowValue?.name ??
                t("smartSurveyor.folders.suggestion.notAssigned")
              }
              className="self-center px-3 text-sm font-medium text-gray-700"
            />
          )}
          {columns.values.map((columnValue, columnIndex) => {
            const floorPlanIds = floorPlanIdsByCell[rowIndex][columnIndex];
            const folderName =
              rowValue !== null &&
              columnValue !== null &&
              floorPlanIds.length > 0
                ? `${columnValue.name}${COMBINED_FOLDER_NAME_SEPARATOR}${rowValue.name}`
                : null;
            return (
              <div
                key={columnValue?.code ?? UNASSIGNED_AXIS_KEY}
                className={clsx(
                  "flex flex-col items-start gap-1.5 px-3 py-2",
                  folderName !== null &&
                    "rounded-lg border border-blue-300 bg-blue-50",
                )}
              >
                {folderName !== null && (
                  <FolderLabel
                    name={folderName}
                    fileCode={null}
                    planCount={null}
                    iconSize={14}
                    className="text-xs font-medium text-blue-700"
                  />
                )}
                <PlanNameList
                  floorPlanIds={floorPlanIds}
                  planNameById={planNameById}
                />
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
};
